import React, { useEffect } from 'react';

import { useFormikContext } from 'formik';

import { getDirtyValues } from 'lib/helpers/utility';

import ChildComponent from './ChildComponent';
import Header from './components/Header/Header';
import Details from './components/Sections/Details/Details';
import Pricing from './components/Sections/Pricing/Pricing';
import Timeline from './components/Sections/Timeline/Timeline';
import UnsavedChanges from './components/UnsavedChanges';

const AppointmentContent = ({
  handleClose,
  appointment,
  setFormValues,
  isLoading,
  isUnsaved,
  setIsUnsaved,
  setFormikValues,
  setAppointmentId
}) => {
  const { values, initialValues, setFieldValue } = useFormikContext();

  const handleFormChange = () => {
    const dirtyValues = getDirtyValues(values, initialValues);
    const upComingDirtyValues = getDirtyValues(appointment, initialValues);
    setFormValues(appointment);
    setTimeout(() => {
      Object.keys(dirtyValues).forEach((key) => {
        if (!upComingDirtyValues[key]) {
          setFieldValue(key, dirtyValues[key]);
        }
      });
    }, 200);
  };

  useEffect(() => {
    if (!isLoading) handleFormChange();
  }, [appointment, isLoading]);

  useEffect(() => {
    setFormikValues(values);
  }, [values]);

  return (
    <>
      <Header appointment={values} handleClose={handleClose} />
      <div className="flex h-full flex-col overflow-y-auto overflow-x-hidden">
        <Details appointment={values} />
        <Pricing setAppointmentId={setAppointmentId} />
        <Timeline />
      </div>
      <UnsavedChanges {...{ isUnsaved, setIsUnsaved, handleClose }} />
      <ChildComponent />
    </>
  );
};

export default AppointmentContent;
